<div class="sticky-buttons" [style.height]="containerHeight" #container>
  <div
    class="sticky-buttons__fixator"
    [class.sticky-buttons__fixator--fixed]="isFixed"
    [class.sticky-buttons__fixator--half-visible]="halfVisible"
    [class.sticky-buttons__fixator--animate]="canAnimate"
  >
    <div class="sticky-button">
      <app-search-subscription-button
        class="full-width"
        origin="results-overview"
      ></app-search-subscription-button>
    </div>

    <div class="sticky-button">
      <button
        class="filled-button filled-button--full-width"
        (click)="openMobileFilter()"
      >
        <i class="filled-button__icon material-icon material-icon--outlined">
          tune
        </i>
        <span class="filled-button__text">
          {{ 'filters.common.modifySearch' | i18n }}
        </span>
      </button>
    </div>
  </div>
</div>
